import React from 'react'
import { Card, Typography } from '@material-ui/core'
import { ArrowRightAltOutlined } from '@material-ui/icons'
import useStyles from './styles'

const SummarySection = ({ info }) => {
    const classes = useStyles()

    const percentObligatory = (info.obligatorio_finalizado / info.obligatorio_total) * 100
    const percentOptional = (info.opcional_finalizado / info.opcional_total) * 100
    return (
        <Card className={classes.mainContainer}>
            <Typography style={{ fontWeight: 'bold' }}>Resumen</Typography>
            <div className={classes.barContainer}>
                <Typography>Obligatorio</Typography>
                <div className={classes.bar} >
                    <div className={classes.completeSection} style={{ width: `${percentObligatory}%` }} />
                    <div className={classes.emptySection} style={{ width: `${100 - percentObligatory}%` }} />
                </div>
                <div className={classes.totalTxtContainer}>
                    <Typography className={classes.totalTxt}>{info.obligatorio_total}</Typography>
                    <ArrowRightAltOutlined />
                    <Typography className={classes.totalTxtPercent}>{info.obligatorio_finalizado} ({Number.isNaN(percentObligatory) ? '0' : percentObligatory.toFixed(2)}%)</Typography>
                </div>
            </div >
            <div className={classes.barContainer}>
                <Typography>Opcional</Typography>
                <div className={classes.bar} >
                    <div className={classes.completeSection} style={{ width: `${percentOptional}%` }} />
                    <div className={classes.emptySection} style={{ width: `${100 - percentOptional}%` }} />
                </div>
                <div className={classes.totalTxtContainer}>
                    <Typography className={classes.totalTxt}>{info.opcional_total}</Typography>
                    <ArrowRightAltOutlined />
                    <Typography className={classes.totalTxtPercent}>{info.opcional_finalizado} ({Number.isNaN(percentOptional) ? '0' : percentOptional.toFixed(2)}%)</Typography>
                </div>
            </div >
        </Card>
    )
}

export { SummarySection }